import { createReducerFromMap } from "@coverme/redux";
import { getCustomFormattedNameFromObject } from "../../services/stringService";
import { isNullOrWhitespace, getAge } from "../../services/stringService";

const initialState = {
    patient: {
        personId: "",
        firstName: "",
        middleInitial: "",
        lastName: "",
        maidenName: "",
        suffix: "",
        address: {
            line1: "",
            line2: "",
            line3: "",
            city: "",
            county: "",
            state: "",
            zipCode: "",
        },
        isPlanningToMoveToJurisdiction: undefined,
        isMailingAddressDifferent: undefined,
        mailingAddress: {
            line1: "",
            line2: "",
            line3: "",
            city: "",
            county: "",
            state: "",
            zipCode: "",
        },
        primaryPhoneNumber: {
            phoneNumber: "",
        },
        phoneNumber: "",
        phoneType: "",
        alternatePhoneNumbers: [],
        email: "",
        dob: null,
        ssn: "",
        pregnancy: {
            isPregnant: null,
            expectedChildren: null,
            expectedDueDate: null,
        },
        documentInfo: {
            documentNumber: "",
            documentType: "",
            issuingState: "",
        },
        isUsCitizen: undefined,
        immigrationStatus: "",
        gender: "",
        maritalStatus: undefined,
        isMarried: null,
        preferredLanguage: "",
        contractConsent: undefined,
        doesHaveId: undefined,
        proofOfAddressProvided: undefined,
        proofOfIdProvided: undefined,
        proofOfResidencyProvided: undefined,
        proofOfCitizenshipProvided: undefined,
        personVerificationModels: undefined,
    },
    isResponsiblePartyDifferentFromPatient: undefined,
    responsibleParty: {
        personId: "",
        firstName: "",
        middleInitial: "",
        lastName: "",
        maidenName: "",
        suffix: "",
        address: {
            line1: "",
            line2: "",
            line3: "",
            city: "",
            county: "",
            state: "",
            zipCode: "",
        },
        isMailingAddressDifferent: undefined,
        pregnancy: {
            isPregnant: null,
            expectedChildren: null,
            expectedDueDate: null,
        },
        mailingAddress: {
            line1: "",
            line2: "",
            line3: "",
            city: "",
            county: "",
            state: "",
            zipCode: "",
        },
        primaryPhoneNumber: {
            phoneNumber: "",
        },
        phoneNumber: "",
        phoneType: "",
        alternatePhoneNumbers: [],
        email: "",
        dob: null,
        ssn: "",
        isUsCitizen: undefined,
        immigrationStatus: "",
        maritalStatus: "",
        isMarried: null,
        gender: "",
        preferredLanguage: "",
        doesLiveWithPatientForMoreThan6Months: undefined,
        relationshipToPatient: "",
        contractConsent: undefined,
        proofOfAddressProvided: undefined,
        proofOfIdProvided: undefined,
        proofOfResidencyProvided: undefined,
        proofOfCitizenshipProvided: undefined,
    },
};

function updateEntry(state, data) {
    let newEntry = data.value;
    if (newEntry.responsibleParty == null) {
        newEntry.responsibleParty = {};
    } else {
        newEntry.responsibleParty.fullName = getCustomFormattedNameFromObject(
            newEntry.responsibleParty,
            "the responsible party"
        );
        newEntry.responsibleParty.age = getAge(newEntry.responsibleParty.dob);
        newEntry.responsibleParty.isMarried = newEntry.responsibleParty.maritalStatus === "Married";
    }
    newEntry.patient.fullName = getCustomFormattedNameFromObject(newEntry.patient, "the patient");
    newEntry.patient.age = getAge(newEntry.patient.dob);
    newEntry.patient.isMarried =
        newEntry.patient.maritalStatus === null
            ? newEntry.patient.maritalStatus
            : newEntry.patient.maritalStatus === "Married";
    if (newEntry.patient.gender === "Unknown") {
        newEntry.patient.gender = "";
    }

    if (newEntry.responsibleParty.gender === "Unknown") {
        newEntry.responsibleParty.gender = "";
    }

    // This is a hack. But this indicates that we are in quick entry
    if (newEntry.patient.isUsCitizen === false && isNullOrWhitespace(newEntry.patient.immigrationStatus)) {
        newEntry.patient.isUsCitizen = undefined;
        newEntry.patient.isMailingAddressDifferent = undefined;
    }

    if (newEntry.patient.mailingAddress == null) {
        newEntry.patient.mailingAddress = initialState.patient.mailingAddress;
    }

    if (newEntry.responsibleParty.mailingAddress == null) {
        newEntry.responsibleParty.mailingAddress = initialState.patient.mailingAddress;
    }

    const encounterId = state.encounterId || data.value.encounterId;
    return newEntry;
}

function getInterview(state, action) {
    return updateEntry(state, { value: action.value.entry });
}

function resetInterview(state, action) {
    return initialState;
}

function setPatientDemographics(state, { value }) {
    return {
        ...state,
        patient: {
            ...state.patient,
            firstName: value.firstName,
            middleInitial: value.middleInitial,
            lastName: value.lastName,
            dob: value.dateOfBirth,
            suffix: value.nameSuffix,
            ssn: value.socialSecurityNumber,
            mrn: value.medicalRecordNumber,
            doesHaveId: value.doesHaveId,
            documentInfo: {
                ...state.patient.documentInfo,
                documentNumber: value.documentId,
                documentType: value.documentType,
                issuingState: value.issuingState,
            },
        },
        serviceStartDate: value.serviceStartDate,
        serviceEndDate: value.serviceEndDate,
    };
}

function updateContractConsent(state, action) {
    if (state.isResponsiblePartyDifferentFromPatient) {
        return {
            ...state,
            responsibleParty: {
                ...state.responsibleParty,
                contractConsent: action.value,
            },
        };
    } else {
        return {
            ...state,
            patient: {
                ...state.patient,
                contractConsent: action.value,
            },
        };
    }
}

function setContractConsent(state, action) {
    if (state.isResponsiblePartyDifferentFromPatient) {
        return {
            ...state,
            responsibleParty: {
                ...state.responsibleParty,
                contractConsent: action.value,
            },
        };
    } else {
        return {
            ...state,
            patient: {
                ...state.patient,
                contractConsent: action.value,
            },
        };
    }
}

function setReVerifiedData(state, action) {
    const personToBeVerified = action.value;

    if (state.responsibleParty?.personId) {
        return {
            ...state,
            responsibleParty: {
                ...state.responsibleParty,
                ...personToBeVerified,
                address: {
                    ...state.responsibleParty.address,
                    ...personToBeVerified,
                },
            },
        };
    } else {
        return {
            ...state,
            patient: {
                ...state.patient,
                ...personToBeVerified,
                address: {
                    ...state.patient.address,
                    ...personToBeVerified,
                },
            },
        };
    }
}

export const entryReducer = createReducerFromMap(initialState, {
    UPDATE_ENTRY_COMPLETE: updateEntry,
    SET_PATIENT_DEMOGRAPHICS: setPatientDemographics,
    GET_INTERVIEW_COMPLETE: getInterview,
    RESET_INTERVIEW: resetInterview,
    UPDATE_CONTRACT_CONSENT_COMPLETE: updateContractConsent,
    SET_CONTRACT_CONSENT_COMPLETE: setContractConsent,
});
